$('.why_diagramm svg').on('click', '.sector', function () {
  var clickedId = $(this).attr('id')
  $('.graph_info.' + clickedId).css('transform', 'scale(1)')
})

$('.why_diagramm').on('click', '.close_info', function () {
  $(this).closest('.graph_info').css('transform', 'scale(0)')
})

$(window).load(function () {
  // on scroll
  if ($('.why_diagramm').length) {
    var target_offset_top = $('.why_diagramm').offset().top
    var target_height = $('.why_diagramm').outerHeight()

    $(window).on('scroll', function () {
      var offset_top = $(document).scrollTop()
      if (offset_top > target_offset_top - target_height) {
        $('.why_diagramm').css('opacity', '1')
      }
    })
  }
})
